module.exports = __webpack_public_path__ + "img/icon-play.2dac0aaa.png";